import React from 'react';

const BlueBanner = (props) => {
    return <div className={props.right ? "blue-banner" : "blue-banner"}>
        <h4>{props.text}</h4>
    </div>
}

export default BlueBanner;